import { marked } from 'marked';

// Shared markdown → raw HTML conversion for broadcast email bodies. Pure (no
// DOM) so it bundles into both the browser preview and the Node server. The
// output is UNSANITISED — every caller must pass it through DOMPurify
// (sanitizeHtmlClient.ts in the browser, sanitizeHtml.ts on the server) before
// it reaches a DOM or an outbound email.
//
// breaks: true — a single newline becomes <br>. Broadcast authors compose in a
// plain textarea and expect line breaks to survive without the GFM
// double-space / blank-line ceremony. gfm: true keeps the familiar GitHub
// flavour (autolinks, etc.).
export function markdownToRawHtml(markdown: string): string {
  // async: false makes parse synchronous; the marked types still widen the
  // return to string | Promise<string>, so narrow it explicitly.
  return marked.parse(markdown, { async: false, gfm: true, breaks: true }) as string;
}

// Compose markdown → HTML → sanitised HTML, with the sanitiser injected by the
// caller (env-specific: browser window vs jsdom). Keeping the composition here
// means the pipeline order (render THEN sanitise) lives in one place.
export function renderSanitizedMarkdown(
  markdown: string,
  sanitize: (html: string) => string,
): string {
  return sanitize(markdownToRawHtml(markdown));
}
